module.exports = __webpack_public_path__ + "static/media/purple-exp-bar.865cf901.png";